export enum SortEnum {
    UNKNOWN = 'unknown',
    DATE = 'date',
    DISTANCE_TO_CITY_CENTER = 'distanceToCityCenter',
    PRICE = 'price',
    PRICE_DESC = 'price_desc',
    PRICE_SQ_METER = 'priceSqMeter',
    PRICE_SQ_METER_DESC = 'priceSqMeter_desc',
    TOTAL_AREA = 'totalArea',
    TOTAL_AREA_DESC = 'totalArea_desc',
    TIME_TO_METRO = 'timeToMetro',
    UPDATE_DATE_DESC = 'updateDate_desc',
    // for backward compatibility
    // TODO remove after few months
    UPDATE_DATE = 'updateDate',
}

export const sortLabelMapping: Record<SortEnum, string> = {
    [SortEnum.UNKNOWN]: 'По умолчанию',
    [SortEnum.DATE]: 'Сначала новые',
    [SortEnum.DISTANCE_TO_CITY_CENTER]: 'Сначала ближе к центру',
    [SortEnum.PRICE]: 'Сначала дешёвые',
    [SortEnum.PRICE_DESC]: 'Сначала дорогие',
    [SortEnum.TOTAL_AREA]: 'Сначала с меньшей площадью',
    [SortEnum.TOTAL_AREA_DESC]: 'Сначала с большей площадью',
    [SortEnum.PRICE_SQ_METER_DESC]: 'Сначала дороже за м²',
    [SortEnum.PRICE_SQ_METER]: 'Сначала дешевле за м²',
    [SortEnum.TIME_TO_METRO]: 'Сначала ближе к метро',
    [SortEnum.UPDATE_DATE_DESC]: 'По дате обновления',
    [SortEnum.UPDATE_DATE]: 'По дате обновления'
};
